import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'

const Concursos = () => {

    return (
        <div className="listado" id="menu">
            <h2 className='tituloAccion'>Concursos</h2>
            <TableContainer>
                <Table sx={{minWidth: 500}} size="small" >
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell style={{textAlign: 'center'}}><a href="./InscripcionConcurso-Consultar">Consultar Inscripciones</a></TableCell>
                            <TableCell style={{textAlign: 'center'}}><a href="./InscripcionBolsa-Consultar">Bolsa de Trabajo</a></TableCell>
                            {sessionStorage.numeroFuncionarioAsociado === '11112' ? <TableCell><a href="./AgregarConcurso">Agregar Concurso</a></TableCell> : null}
                        </TableRow>
                        <TableRow>
                            {sessionStorage.numeroFuncionarioAsociado === '11112' ? <TableCell><a href="./EnviarMailsConcurso">Enviar Mails Pendientes</a></TableCell> : null}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default Concursos